import CredentialAuth from "@/components/auth/CredentialAuth";

export default function AdminLogin() {
  return (
    <CredentialAuth
      role="admin"
      eyebrow="Restricted access"
      title="Admin Portal"
      description="Full platform oversight for clients, coaches, training content, integrations, payments and operational settings."
      notice="Only registered administrator email addresses can enter this portal."
    />
  );
}
